import React, { createContext } from 'react'

import { TravelTypeEnum } from '../../../lib/graphql'

export interface ITravelTypeContext {
  travelType: TravelTypeEnum
  setTravelType:
    | React.Dispatch<React.SetStateAction<TravelTypeEnum>>
    | ((value: TravelTypeEnum) => void)
}

export const TravelTypeContext = createContext({} as ITravelTypeContext)
